<div class="active-container">
  <div *ngIf="active" class="ml-8px light-bright active"></div>
  <div *ngIf="active" class="text">Active</div>
  <div *ngIf="!active" class="ml-8px light-bright inactive"></div>
  <div *ngIf="!active" class="text">Inactive</div>
</div>
